export const useNewsletter = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const isSubscribing = ref(false)
    const subscribeStatus = ref<{ success: boolean; message: string } | null>(null)

    const subscribe = async (
        email: string,
        firstName: string,
        lastName: string,
        phone?: string,
        options?: { website?: string; formLoadedAt?: number }
    ) => {
        isSubscribing.value = true
        subscribeStatus.value = null

        try {
            const result = await $fetch<{ success: boolean; message: string }>(`${apiBase}/oxoweb/newsletter/subscribe`, {
                method: 'POST',
                body: {
                    email,
                    firstName,
                    lastName,
                    phone,
                    website: options?.website ?? '',
                    formLoadedAt: options?.formLoadedAt
                }
            })
            subscribeStatus.value = { success: result.success, message: result.message }
            return result
        } catch (error: any) {
            const message = error?.data?.message || 'Une erreur est survenue. Veuillez réessayer.'
            subscribeStatus.value = { success: false, message }
            throw error
        } finally {
            isSubscribing.value = false
        }
    }

    const confirm = async (token: string) => {
        try {
            const result = await $fetch<{ success: boolean; message: string }>(`${apiBase}/oxoweb/newsletter/confirm/${token}`)
            return result
        } catch (error: any) {
            return { success: false, message: error?.data?.message || 'Lien de confirmation invalide ou expiré.' }
        }
    }

    const unsubscribe = async (token: string, reason?: string) => {
        try {
            const query = reason ? `?reason=${encodeURIComponent(reason)}` : ''
            const result = await $fetch<{ success: boolean; message: string }>(`${apiBase}/oxoweb/newsletter/unsubscribe/${token}${query}`)
            return result
        } catch (error: any) {
            return { success: false, message: error?.data?.message || 'Une erreur est survenue.' }
        }
    }

    const resetStatus = () => {
        subscribeStatus.value = null
    }

    return {
        isSubscribing,
        subscribeStatus,
        subscribe,
        confirm,
        unsubscribe,
        resetStatus
    }
}
